import { combineReducers } from 'redux'
import { routerReducer as routing } from 'react-router-redux'
import { reducer as form } from 'redux-form'

import * as auth from './modules/auth'
import * as bookingSetup from './modules/bookingSetup'
import * as service from './modules/service'
import * as recurrence from './modules/recurrence'
import * as search from './modules/search'
import * as aliada from './modules/aliada'
import * as entities from './modules/entities'
import * as user from './modules/user'
import * as error from './modules/error'

export default combineReducers({
  routing,
  form,
  [entities.constants.NAME]: entities.reducer,
  [error.constants.NAME]: error.reducer,
  [auth.constants.NAME]: auth.reducer,
  [bookingSetup.constants.NAME]: bookingSetup.reducer,
  [service.constants.NAME]: service.reducer,
  [recurrence.constants.NAME]: recurrence.reducer,
  [search.constants.NAME]: search.reducer,
  [aliada.constants.NAME]: aliada.reducer,
  [user.constants.NAME]: user.reducer
})



// WEBPACK FOOTER //
// ./src/redux/reducer.js